// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3W8rW","list":"PatternAutocomplete_list__3DOnD"};